module.exports = __webpack_public_path__ + "img/IMG_2671_L_Wood_MockedUp.02f18e79.jpg";